import React from "react";

interface OrderSummaryProps {
  totalMrp: number;
  couponDiscount: number;
  rewardDiscount: number;
  walletDiscount?: number;
  platformFee: number;
  smallOrderFee?: number;
  deliveryFee: number;
  donation: number;
  taxAmount: number;
  /**
   * Order total before wallet deduction
   */
  grandTotal: number;
  /**
   * Final payable amount
   */
  gatewayAmount?: number;
  buttonTitle?: string;
  showButton?: boolean;
  remainingAmount?:number
}

const OrderSummary: React.FC<OrderSummaryProps> = ({
  totalMrp,
  couponDiscount,
  rewardDiscount,
  walletDiscount = 0,
  platformFee,
  smallOrderFee = 0,
  deliveryFee,
  donation,
  taxAmount,
  grandTotal,
  gatewayAmount,
  remainingAmount=0
}) => {
  return (
    <div className="w-full bg-white rounded-2xl border border-gray-200 shadow-sm p-5">
      {/* Title */}
      <p className="text-base font-bold text-logoHeading mb-5 tracking-wide">
        ORDER SUMMARY
      </p>

      {/* Pricing Rows */}
      <div className="flex flex-col gap-3.5 text-base">
        {/* Sub Total */}
        <div className="flex justify-between">
          <p className="text-mainBrandColor font-medium">Total</p>
          <p className="font-semibold">AED {totalMrp.toFixed(2)}</p>
        </div>
        {remainingAmount > 0 && (   <div className="flex justify-between">
          <p className="text-mainBrandColor font-medium">Remaining Amount</p>
          <p className="font-semibold">AED {remainingAmount.toFixed(2)}</p>
        </div>)}
            

        {/* Coupon */}
        {couponDiscount > 0 && (
          <div className="flex justify-between">
            <p className="text-mainBrandColor font-medium">Coupon Discount</p>
            <p className="text-red-500 font-semibold">
              - AED {couponDiscount.toFixed(2)}
            </p>
          </div>
        )}

        {/* Reward */}
        {rewardDiscount > 0 && (
          <div className="flex justify-between">
            <p className="text-mainBrandColor font-medium">Reward Points</p>
            <p className="text-red-500 font-semibold">
              - AED {rewardDiscount.toFixed(2)}
            </p>
          </div>
        )}

        {/* VAT */}
        {taxAmount > 0 && (
          <div className="flex justify-between">
            <p className="text-mainBrandColor font-medium">VAT</p>
            <p className="font-semibold">AED {taxAmount.toFixed(2)}</p>
          </div>
        )}

        {/* Platform Fee */}
        {platformFee > 0 && (
          <div className="flex justify-between">
            <p className="text-mainBrandColor font-medium">Platform Fee</p>
            <p className="font-semibold">AED {platformFee.toFixed(2)}</p>
          </div>
        )}

        {/* Small Order Fee */}
        {smallOrderFee > 0 && (
          <div className="flex justify-between">
            <p className="text-mainBrandColor font-medium">Small Order Fee</p>
            <p className="font-semibold">AED {smallOrderFee.toFixed(2)}</p>
          </div>
        )}

        {/* Delivery */}
        <div className="flex justify-between">
          <p className="text-mainBrandColor font-medium">Delivery Fee</p>
          {deliveryFee > 0 ? (
            <p className="text-green-600 font-semibold">
              AED {deliveryFee.toFixed(2)}
            </p>
          ) : (
            <p className="text-green-600 font-bold">FREE</p>
          )}
        </div>

        {/* Donation */}
        {donation > 0 && (
          <div className="flex justify-between">
            <p className="text-mainBrandColor font-medium">Donation</p>
            <p className="font-semibold">AED {donation.toFixed(2)}</p>
          </div>
        )}

        {/* Wallet Discount */}
        {walletDiscount > 0 && (
          <div className="flex justify-between items-center">
            <p className="font-medium text-mainBrandColor">Wallet Applied</p>
            <p className="text-red-500 font-bold">
              - AED {walletDiscount.toFixed(2)}
            </p>
          </div>
        )}
      </div>

      <div className="border-t my-5" />

      {/* Order Total */}
      <div className="flex justify-between items-center">
        <p className="font-bold text-xl text-gray-800">Order Total</p>
        <p className="text-2xl font-extrabold text-mainBrandColor">
          AED {gatewayAmount?.toFixed(2)}
        </p>
      </div>

      {/* Payable Amount Section */}
      {/* {walletDiscount > 0 && (
        <>
          <div className="border-t my-5" />
          <div className="flex justify-between items-center">
            <p className="font-bold text-xl text-gray-800">Payable Amount</p>
            <p className="text-2xl font-extrabold text-mainBrandColor">
              AED {gatewayAmount?.toFixed(2)}
            </p>
          </div>
        </>
      )} */}
    </div>
  );
};

export default OrderSummary;